import { BookOpen, NotebookTabs } from 'lucide-react';
import { chapterNav } from '../data';
import type { PageId } from '../types';

interface ChapterRailProps {
  activePage: PageId;
  onPageChange: (page: PageId) => void;
}

export function ChapterRail({ activePage, onPageChange }: ChapterRailProps) {
  return (
    <aside className="chapter-rail" aria-label="Chapter navigation">
      <div className="brand">
        <BookOpen aria-hidden="true" />
        <div>
          <strong>我的草原<br />旅行科学书</strong>
        </div>
      </div>

      <nav className="chapter-list">
        {chapterNav.map((item) => {
          const Icon = item.icon;
          const active = item.id === activePage;

          return (
            <button
              className={active ? 'chapter-button active' : 'chapter-button'}
              key={item.id}
              onClick={() => onPageChange(item.id)}
              title={`${item.day} · ${item.title}`}
              type="button"
            >
              <Icon aria-hidden="true" />
              <span>
                <b>{item.day}</b>
                <small>{item.title}</small>
                <em>{item.subtitle}</em>
              </span>
            </button>
          );
        })}
      </nav>

      <div className="rail-actions">
        <button type="button">
          <NotebookTabs aria-hidden="true" />
          我的发现
        </button>
        <button type="button">
          <BookOpen aria-hidden="true" />
          阅读进度
        </button>
      </div>
    </aside>
  );
}
